import config from 'js/app/config';

import type { Testimonial } from 'bundles/unified-description-page-common/components/modules/testimonials/TestimonialItem';

import FCNDDropdown2 from 'images/xdp/fcnd_dropdown_2.jpg';

import _t from 'i18n!nls/xdp';

const getTestimonials = (): Array<Testimonial> => {
  return [
    {
      name: 'Felipe M.',
      learnerSince: 2018,
      imageSrc: `${config.url.resource_assets}growth_testimonials/passionate_learner/Felipe_Moitta.png`,
      quote: _t(
        'To be able to take courses at my own pace and rhythm has been an amazing experience. I can learn whenever it fits my schedule and mood.'
      ),
    },
    {
      name: 'Jennifer J.',
      learnerSince: 2020,
      imageSrc: `${config.url.resource_assets}growth_testimonials/passionate_learner/Jennifer_John.png`,
      quote: _t(
        'I directly applied the concepts and skills I learned from my courses to an exciting new project at work.'
      ),
    },
    {
      name: 'Larry W.',
      learnerSince: 2021,
      imageSrc: `${config.url.resource_assets}growth_testimonials/passionate_learner/Larry_Tao_Wang_1.png`,
      quote: _t(
        `When I need courses on topics that my university doesn't offer, Coursera is one of the best places to go.`
      ),
    },
    {
      name: 'Chaitanya A.',
      imageSrc: `${config.url.resource_assets}growth_testimonials/passionate_learner/Chaitanya_Anand.png`,
      quote: _t(
        `Learning isn't just about being better at your job: it's so much more than that. Coursera allows me to learn without limits.`
      ),
    },
  ];
};

export const getVideoTestimonials = () => {
  return [
    {
      authorName: 'Karrim 1',
      authorOrganization: 'Infosys',
      authorTitle: 'Associate Analyst',
      quote:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud',
      videoEmbedUrl: 'https://www.youtube.com/embed/udZz2_E4SXw',
      videoPlaceholderImage: { url: FCNDDropdown2 },
    },
    {
      authorName: 'Karrim 2',
      authorOrganization: 'Infosys',
      authorTitle: 'Associate Analyst',
      quote:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud',
      videoEmbedUrl: 'https://www.youtube.com/embed/udZz2_E4SXw',
      videoPlaceholderImage: { url: FCNDDropdown2 },
    },
    {
      authorName: 'Karrim 3',
      authorOrganization: 'Infosys',
      authorTitle: 'Associate Analyst',
      quote:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud',
      image: { url: FCNDDropdown2 },
    },
  ];
};

export default getTestimonials;
